import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    x="0px"
    y="0px"
    viewBox="0 0 176.4 103.8"
    style={{
      enableBackground: "new 0 0 176.4 103.8",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {"\n\t.iso_front_right{fill:none;stroke:" +
        strokeColor +
        ";stroke-width:0.6046;stroke-miterlimit:10;}\n\t.st1{display:none;fill:none;stroke:" +
        strokeColor +
        ";stroke-width:0.6046;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:" +
        strokeColor +
        ";stroke-width:0.6046;stroke-miterlimit:9.9964;}\n\t.st3{fill:none;stroke:" +
        strokeColor +
        ";stroke-width:0.6676;stroke-miterlimit:10.0006;}\n"}
    </style>
    <g id="Layer_1_00000128466083391161417530000010368623512704411069_">
      <g id="Layer_1_00000105402755068823616560000004557812799981369480_">
        <g id="Layer_4">
          <path
            className="iso_front_right"
            d="M115.7,55.8c-0.5-1.2-0.2-1.5-1.2-3c-0.5-3.2-26.4-17.2-27.6-16.9"
          />
          <g id="Layer_2_00000058550286679134392200000015710878381421217926_">
            <line className="st1" x1={81.1} y1={83.7} x2={22.6} y2={65.3} />
            <path className="iso_front_right" d="M106.5,94.6c17.7,2,57.7-4.5,61.5-5.7" />
          </g>
        </g>
        <path
          className="iso_front_right"
          d="M123.4,61.3l12.2-0.2c1.5,0,2.5-1.2,2.5-2.7l0,0c0-4.2-4-7.2-8-7.2L118,51.3c-1.5,0-2.5,1.2-2.5,2.7l0,0 C115.7,58,119.2,61.3,123.4,61.3z"
        />
      </g>
      <g id="Layer_2_00000139272764159754113790000002209323745162615683_">
        <g id="Layer_1_00000103222774645540541050000005139477364094571910_">
          <g id="Layer_4_00000049934109083756324810000015099088110705302955_">
            <path
              className="iso_front_right"
              d="M84.1,56.3c-8,3.2-7.5,19.7-8,23.6c0,0,0,1.7,0,2.2"
            />
            <path
              className="iso_front_right"
              d="M102.3,74c0.2-0.2,5.5-7,6.7-8.7c0,0,7.2-6.5,8-7.5"
            />
            <path
              className="iso_front_right"
              d="M85.1,84.9c-1-7,2.2-12.7,6-12.9c4-0.2,8,4.7,8.5,11.7c1,7-2.2,12.7-6,12.9C89.6,97.1,86.1,91.9,85.1,84.9z "
            />
            <path
              className="iso_front_right"
              d="M12.7,63.8c0,4.5,1.7,8.5,4,8.5c2.2,0,4-4,4-8.5s-1.7-8.5-4-8.5C14.4,55.3,12.7,59.3,12.7,63.8"
            />
            <g id="Layer_2_00000035522350009171966180000007139185092383136160_">
              <path className="iso_front_right" d="M86.6,35.9c3.2-0.5,21.4-2.2,22.4-2.7" />
              <path className="iso_front_right" d="M107.5,60.5" />
              <path className="iso_front_right" d="M123.2,62" />
              <path className="iso_front_right" d="M123.2,62" />
              <path className="iso_front_right" d="M111,55.6" />
              <path className="iso_front_right" d="M122.9,59" />
            </g>
          </g>
          <path className="iso_front_right" d="M69.4,10.5c0.2,0.2,16.4,24.9,17.2,25.6" />
          <path className="iso_front_right" d="M17.7,46.6c3-0.2,5.5,8,7,19.7" />
          <path className="iso_front_right" d="M86.6,35.9c-0.2,2.5-2.2,15.9-2.5,20.7" />
        </g>
        <ellipse
          transform="matrix(0.9953 -9.653204e-02 9.653204e-02 0.9953 -7.7206 9.4499)"
          className="st2"
          cx={93.8}
          cy={84.5}
          rx={1}
          ry={1.2}
        />
        <ellipse className="st3" cx={16.7} cy={63.8} rx={0.5} ry={0.5} />
        <path
          className="iso_front_right"
          d="M106.8,94.9l-0.2-3.2C105,78,99.8,63,90.1,60.8l-1.7-0.2c-8.5,0.2-9,9.7-9.7,17.4l-0.2,5"
        />
        <path
          className="iso_front_right"
          d="M96.3,64.3h-3c-13.2,0.5-12.2,15.9-11.7,19.2l0.2,2.5c2.5,14.9,13.9,19.9,22.9,13.7c3-2.2,3.7-4.7,3.7-4.7"
        />
        <path
          className="iso_front_right"
          d="M27.4,67.3L27.4,67.3c-0.2,1-1.2,5-3.7,6.5c-2.2,1.7-9,3.7-11.5-5.5c-0.2-1.2-0.5-2.7-0.5-4.2 c-0.2-1.2,0.2-4.7,0.2-5.2c0.2-1.7,1.2-6.5,5.5-6.7h2"
        />
        <path
          className="iso_front_right"
          d="M11.7,61.8v-0.5l0.5-7c0.5-4,1.2-5,2.5-5.5c0.5-0.2,1-0.2,1.5-0.2c3.2,0.7,5.2,6.7,6.5,17.2"
        />
      </g>
      <path className="iso_front_right" d="M137.6,55.8c1.7,0,28.1-2.5,29.1-2.5" />
      <polyline
        className="iso_front_right"
        points="165.3,67 153.3,68.5 154.3,76.2 166.8,74.7  "
      />
    </g>
    <g id="Layer_3">
      <path
        className="iso_front_right"
        d="M68.4,27.7h1.2l3.7,3.2l0.5,0.5l-2.2,1c-1.5,0.5-3.2,1-4.7,0.2l-1.5-0.5c-1-0.2-1.7-0.5-2.7-0.5l-7.5-0.5 c-1,0-1.5-0.5-1.5-1.5l-0.2-4c0-0.5,0.2-1.2,1.2-1.5l4.7-1.5c1.5-0.2,3.2-0.2,4.7,0.5l2.2,1.5L68.4,27.7z"
      />
      <line className="iso_front_right" x1={68.4} y1={27.7} x2={65.4} y2={32.4} />
    </g>
    <line className="iso_front_right" x1={22.4} y1={65.8} x2={78.6} y2={82.9} />
  </svg>
);
export default SvgComponent;
